import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../services";
import { Globals } from '../../../globals';
import { TakeawayServices } from '../../takeaway/services';

/**
 * Generated class for the TpvRoomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-select',
  templateUrl: 'tpv-select.html',
})
export class TpvRoomPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public takeawayServices: TakeawayServices) {

  }

  ionViewWillEnter() {
    /*if (this.globals.restaurant.tutorial_tpv == undefined || !this.globals.restaurant.tutorial_tpv) {
      this.navCtrl.push(TpvTutorialSlidePage);
    }*/
  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-select/tpv-select.ts